import script from "./WmsAgreementCancelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WmsAgreementCancelModal.vue?vue&type=script&setup=true&lang=js"

import "./WmsAgreementCancelModal.vue?vue&type=style&index=0&id=52dd40fd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52dd40fd"]])

export default __exports__